export default __webpack_public_path__ + "static/media/weapon3.bf29d9e7.png";